<template>
  <aha-modal
    :title="modalTitle"
    classesModal="modal-cancel-process modal-cancel-success"
    @hide="handleCloseModal"
  >
    <div
      v-html="endDateText"
    ></div>
    <template #action>
      <aha-antd-button
        v-aha-emit-action
        name="subscription-cancelled"
        @click="handleCloseModal"
      >
        {{ $i18nPresenter.t('Got it') }}
      </aha-antd-button>
    </template>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  props: {
    propData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      plan: (state) => state.plan,
      isRemoveCardPurpose: (state) => state.isRemoveCardPurpose,
    }),
    endDateText() {
      if (this.propData && this.propData.subscriptionEndDate) {
        const time = moment(this.propData.subscriptionEndDate)
          .locale('en')
          .format('hh:mm a')
        const date = moment(this.propData.subscriptionEndDate)
          .locale('en')
          .format('DD MMM YYYY')

        return this.$i18nPresenter.t('your_plan_active_until', {
          plan: this.planName,
          time,
          date,
        })
      }

      return null
    },
    planName() {
      return this.plan && this.plan.name
    },
    modalTitle() {
      return this.isRemoveCardPurpose
        ? this.$i18nPresenter.t('card_removed')
        : this.$i18nPresenter.t('subscription_cancelled')
    },
  },
  mounted() {
    this._emitTrackEvent('Cancel subscription')
  },
  methods: {
    handleCloseModal() {
      window.location.reload()
    },
    _emitTrackEvent(action) {
      this.$emit('trackEvent', {
        eventAction: action,
      })
    },
  },
}
</script>
